import React from 'react';
import { InfoCircle } from '@saleshandy/icons';
import Switch, {
  Size,
} from '../../../../../../shared/design-system/components/atoms/switch';
import { ShAccountSettingsCode } from '../../../../enums/admin-settings';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../shared/design-system/components/overlay';
import Checkbox from '../../../../../../shared/design-system/components/atoms/checkbox';

type NestedSetting = {
  label: React.ReactNode;
  checked: boolean;
  onChange: () => void;
  disabled: boolean;
};

type IProps = {
  checked: boolean;
  onChange: (code: ShAccountSettingsCode) => void;
  label: string | React.ReactNode;
  isDisabled?: boolean;
  code: ShAccountSettingsCode;
  learnMoreLink?: string;
  nestedSettings?: NestedSetting[];
  tooltipText?: string;
  tooltipOnInfoIcon?: string;
};

const AdminSettingToggle: React.FC<IProps> = ({
  checked,
  onChange,
  label,
  isDisabled = false,
  code,
  learnMoreLink = '',
  nestedSettings = [],
  tooltipText = '',
  tooltipOnInfoIcon = '',
}) => (
  <div className="admin-setting-toggle">
    <div className="d-flex align-items-center gap-4">
      <Switch
        className="admin-setting-toggle--switch"
        checked={checked}
        onChange={() => onChange(code)}
        size={Size.Small}
        disabled={isDisabled}
        tooltip={tooltipText}
        placement={Placement.Top}
      />

      <div className="admin-setting-toggle--label">
        <span>{label}</span>
        {learnMoreLink && (
          <a href={learnMoreLink} target="_blank" rel="noreferrer">
            Learn More
          </a>
        )}
      </div>
      {tooltipOnInfoIcon && (
        <OverlayTooltip text={tooltipOnInfoIcon} className="tooltip-xxl">
          <InfoCircle className="gray-txt-15" />
        </OverlayTooltip>
      )}
    </div>

    {nestedSettings && (
      <div className="admin-setting-toggle--nested">
        {nestedSettings.map((setting, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className="admin-setting-toggle--nested-item"
          >
            <Checkbox
              id={`${index}`}
              checked={setting.checked}
              onChange={setting.onChange}
              label={setting.label}
              disabled={setting.disabled}
            />
          </div>
        ))}
      </div>
    )}
  </div>
);

export default AdminSettingToggle;
